import axios from 'axios';

// Configure axios defaults
// Use environment variable for API URL, fallback to localhost for development
axios.defaults.baseURL = import.meta.env.VITE_API_URL || 'http://localhost:5000';

// Add request interceptor to include auth token
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle auth errors
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Only redirect to admin login if user is on an admin route
            const isAdminRoute = window.location.pathname.startsWith('/admin');
            if (isAdminRoute) {
                localStorage.removeItem('adminToken');
                window.location.href = '/admin/login';
            }
        }
        return Promise.reject(error);
    }
);

// Product API
export const productAPI = {
    getAll: (params = {}) => axios.get('/api/products', { params }),
    getById: (id) => axios.get(`/api/products/${id}`),
    getPopular: () => axios.get('/api/products/popular/list'),
    create: (data) => axios.post('/api/products', data),
    update: (id, data) => axios.put(`/api/products/${id}`, data),
    delete: (id) => axios.delete(`/api/products/${id}`),
    toggleStatus: (id) => axios.patch(`/api/products/${id}/toggle-status`),
    togglePopular: (id) => axios.patch(`/api/products/${id}/toggle-popular`),
    getCategories: () => axios.get('/api/products/meta/categories')
};

// Category API
export const categoryAPI = {
    getAll: () => axios.get('/api/categories'),
    getById: (id) => axios.get(`/api/categories/${id}`),
    create: (data) => axios.post('/api/categories', data),
    update: (id, data) => axios.put(`/api/categories/${id}`, data),
    delete: (id) => axios.delete(`/api/categories/${id}`),
    toggleStatus: (id) => axios.patch(`/api/categories/${id}/toggle-status`)
};

// Auth API
export const authAPI = {
    login: (credentials) => axios.post('/api/auth/login', credentials),
    getProfile: () => axios.get('/api/auth/me'),
    createAdmin: (data) => axios.post('/api/auth/create-admin', data)
};

// Order API
export const orderAPI = {
    create: (data) => axios.post('/api/orders', data),
    getAll: (params = {}) => axios.get('/api/orders', { params }),
    getById: (id) => axios.get(`/api/orders/${id}`),
    getStats: () => axios.get('/api/orders/stats'),
    exportData: (params = {}) => axios.get('/api/orders/export/data', { params }),
    updateDeliveryStatus: (id, deliveryStatus) => axios.patch(`/api/orders/${id}/delivery-status`, { deliveryStatus }),
    delete: (id) => axios.delete(`/api/orders/${id}`)
};

// Settings API
export const settingsAPI = {
    getAll: () => axios.get('/api/settings'),
    getByKey: (key) => axios.get(`/api/settings/${key}`),
    update: (key, data) => axios.put(`/api/settings/${key}`, data),
    delete: (key) => axios.delete(`/api/settings/${key}`)
};

export default axios;